import React from 'react';
// import { Link } from "react-router-dom";
// import Preview from '../components/ApiPreview/apipreview'
// import { CodeSandboxOutlined } from '@ant-design/icons';
// import scrollToComponent from '@kevinkl3/react-scroll-to-component';
import { Layout } from 'antd';
import { PageFooter } from './HomePage';
// import { ScrollTo } from 'react-scroll-to';
// import history from "../../util/history";
import { Authentication, MenuItemGroup, RestaurantGroup } from '../Components/DocComponents';
// import ApiPreviewWidget from './ApiPreview';
import '../styles/doc-style.css';
// import DocSideBar from './DocSidebar';
import TopNav from '../Components/TopNav';
import MetadataManager from '../Components/MetadataManager';

const DocsPage = () => {
    const sandbox = false;
    return (
        <Layout className="layout overflow-hidden doc-page" >
      <MetadataManager 
        title="API Documentation | MenuPortal"
        description="Comprehensive API documentation for MenuPortal's restaurant data API. Learn how to integrate and utilize our JSON endpoints."
        keywords="API docs, developer documentation, restaurant API integration, MenuPortal API, JSON API documentation"
      />
      <TopNav dark={true} transparent={false} addClass="home-navbar" />
        <div className="container mt-5 mb-5">
            <div className="row mt-5">
              <div className="col">


                <div className="row mt-2 mb-5"><div className="col">

                <div className="container-fluid">
                    <section>
                        {/* <a id="intro"></a> */}
                        <h1 className="font-weight-bold">MenuPortal API Introduction</h1>
                        <p className="lead">MenuPortal is an API providing access to a Database of over 400,000 Restaurant Menus in the US. </p>
                        <hr className='style-two'/>  
                        <p>The API is a RESTful API, has resource-oriented URLs, returns JSON-encoded responses, and returns standard HTTP response codes.</p>
                        <p className="font-weight-bold text-dark">The base url for the API is: <code className="code-base-url mt-3  p-2 pr-4 pl-4 fira-code-spaced fira-code-400 bg-custom-dark text-yellow">https://menuapi.apix.site/api</code></p>
                    </section>
                    <div className="row mt-5 mb-5"><div className="col"><hr className="bg-dark"/></div></div>
                    <section className="d-none">
                        {/* <a id="authentication"></a> */}
                        <h2 className="font-weight-bold">Authentication</h2>
                        <p>Your API requests are authenticated using API keys. To use any API endpoint, you must pass an <code>X-API-Key</code> header with each request.</p>
                        
                        <Authentication/>
                    </section>
                  {/* <div className="row mt-5 mb-5"><div className="col"><hr className="bg-dark"/></div></div> */}
                  <section>
                        {/* <a id="restaurants"></a> */}
                        <h2 className="font-weight-bold">Restaurants</h2>
                        <p>The API has over 300,000 individual restaurants in the datastore. You can pull these documents by the unique Restaurant ID or you can search the data.</p>
                        {sandbox ? <RestaurantGroup sandbox={sandbox}/> : <RestaurantGroup sandbox={sandbox}/>} 
                    </section>
                    <div className="row mt-5 mb-5"><div className="col"><hr className="bg-dark"/></div></div>
                    <section>
                        {/* <a id="menu-items"></a> */}
                        <h2 className="font-weight-bold">Menu Items</h2>
                        <p>The API has over 1,000,000 individual menu items in the datastore. You can pull these documents by the unique Menu Item ID or you can search the data.</p>
                        <MenuItemGroup sandbox={sandbox}/>
                    </section>


              



                </div>



                </div></div>

              </div>

            </div>
          </div>
         
        
        <PageFooter/>
        </Layout>

    );
};

export default DocsPage;